import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.JDPRODUCT_SET_JDPRODUCT_LIST]: (state, payload) => {
    state.jdproductList = payload.data.exProductList
  },
  [mutationsTypes.JDPRODUCT_SET_META]: (state, payload) => {
    state.meta = payload.meta
  },
  [mutationsTypes.JDPRODUCT_SET_JDPRODUCT_MAP]: (state, payload) => {
    state.jdproductMap = payload
  }
}

export default Mutations
